<template>
  <v-card class="fpv-reports-table">
    <v-card-title class="toolbar white--text">
      <h2>IP Signings</h2>
      <v-spacer />
      <v-text-field
        v-model="search"
        primary
        dark
        solo-inverted
        flat
        append-icon="search"
        label="Search by user_id"
        single-line
        hide-details
      />
      <v-btn
        dark
        color="blue"
        @click.stop="openCreateIpSigningDocumentDialog()"
      >
        <v-icon dark>
          add
        </v-icon>Create Document
      </v-btn>
    </v-card-title>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="ipSignings"
      :loading="loading"
      :expand="false"
      item-key="created_at"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr
          :active="props.selected"
          @click="props.expanded = !props.expanded"
        >
          <td>
            {{ props.item.document_type }}
          </td>
          <td>
            {{ props.item.user_id }}
          </td>
          <td>
            {{ props.item.document_id }}
          </td>
          <td>
            {{ props.item.file_name }}
          </td>
          <td>
            {{ props.item.strategy_id }}
          </td>
          <td>
            {{ props.item.brand }}
          </td>
          <td>
            {{ props.item.date_of_creation }}
          </td>
          <td>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="warning"
                  flat
                  icon
                  v-on="on"
                  @click="download(props.item)"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
              <span>download</span>
            </v-tooltip>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="blue"
                  flat
                  icon
                  v-on="on"
                  @click="preview(props.item)"
                >
                  <v-icon>preview</v-icon>
                </v-btn>
              </template>
              <span>preview</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <create-ip-signing-document
      :dialog="isOpenCreationDialog"
      :submit-action="submitCreateIpSigningDocument"
      :cancel-action="cancelCreationModal"
      :create-document-error="createError"
    />
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { formatDateSmall } from '@/utils/dateFormats';
import { toQueryString, setQuery } from '@/helpers';
import CreateIpSigningDocument from '@/components/ire/CreateIpSigningDocument';

export default {
  name: 'IpSigningsTable',
  components: {
    CreateIpSigningDocument,
  },
  props: {
    ipSignings: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoadTableData: false,
      search: undefined,
      isOpenCreationDialog: false,
      createError: '',
      selected: [],
      filters: {
        createdAt: [],
        state: [],
      },
      headers: [
        {
          text: 'Document Type',
          align: 'left',
          value: 'document_type',
        },
        {
          text: 'User Id',
          align: 'left',
          value: 'user_id',
        },
        {
          text: 'Document Id',
          align: 'left',
          value: 'document_id',
        },
        {
          text: 'File Name',
          align: 'left',
          value: 'file_name',
        },
        {
          text: 'Strategy Id',
          align: 'left',
          value: 'strategy_id',
        },
        {
          text: 'Brand',
          align: 'left',
          value: 'brand',
        },
        {
          text: 'Date of Creation',
          align: 'left',
          value: 'date_of_creation',
        },
        {
          text: 'Actions',
          align: 'left',
          value: 'actions',
        },
      ],
      formatDateSmall,
    };
  },
  watch: {
    search: {
      immediate: false,
      handler(search, oldSearch) {
        if (search !== oldSearch) {
          setQuery(
            {
              search,
            },
            this.$route,
            this.$router,
          );
          this.refreshTable();
        }
      },
    },
  },
  methods: {
    ...mapActions(['getIpSignings', 'downloadFile', 'createIpSigningDocument']),
    refreshTable() {
      const query = toQueryString({
        userId: this.search,
      });
      if (typeof window.LIT !== 'undefined') {
        clearTimeout(window.LIT);
      }
      window.LIT = setTimeout(() => {
        this.getIpSignings(query);
      }, 1000);
    },
    openCreateIpSigningDocumentDialog() {
      this.createError = '';
      this.isOpenCreationDialog = true;
    },
    cancelCreationModal() {
      this.isOpenCreationDialog = false;
      this.createError = '';
    },
    async submitCreateIpSigningDocument(data) {
      try {
        await this.createIpSigningDocument(data);
        this.isOpenCreationDialog = false;
      } catch (e) {
        this.createError = e.response.data.message;
        this.isOpenCreationDialog = true;
      }
    },
    async preview(document) {
      this.downloadFile({
        userId: document.user_id,
        documentId: document.document_id,
      }).then((response) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        window.open(window.URL.createObjectURL(blob));
      });
    },
    async download(file) {
      this.downloadFile({
        userId: file.user_id,
        documentId: file.document_id,
      }).then((response) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = file.file_name;
        link.click();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fpv-reports-table{
  a {
    text-decoration: none;
    color: black;
  }

  .toolbar {
    background-color: #1a4c7d;
    color: white;
  }

  .infoLabel {
    margin-left: 16px;
  }

  .countLabel {
    color: #fff;
  }
  .expanded-details {
    background-color: #eaeaea;
    padding: 20px;
  }

  .v-select{
        flex: 1;
  }

  table.v-table {
    td:not(:first-child),
    th:not(:first-child) {
      padding: 0 1% !important;
    }
  }

  .v-card__title.subheading{
    .v-icon{
      margin-right:10px;
    }
  }
  .v-input{
    &.security_wallet{
      min-width: 350px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/ire/IpSigningsTable.vue